
import classNames from 'classnames'

import styles from './table.module.sass'

import BlockWrapper from '../layout/block_wrapper'
import ScrollAnimation from '../layout/scroll_animation'

function Table(props) {

	const fields = props.fields

	return <BlockWrapper {...props} fullbleed={props.accordionContent ? false : true} className={classNames(styles.table)}>
		<ScrollAnimation styles={styles}>
			<table>
				<thead>
					<tr>
						{fields.table.header.map((header, header_index) => {
							return <th><span>{header.c}</span></th>
						})}
					</tr>
				</thead>
				<tbody>
				{fields.table.body.map((body, body_index) => {
					return <tr>
						{body.map((data, data_index) => {
							return <td>{data.c}</td>
						})}
					</tr>
				})}
				</tbody>
			</table>
		</ScrollAnimation>
	</BlockWrapper>
}

export default Table